import * as types from 'actions/actionTypes';
import initialState from 'reducers/initialState';

export default (state = initialState.invoice, action) => {
  switch (action.type) {
    case types.INVOICE_LOAD.SUCCESS:
      return { ...action.invoice };

    case types.LOG_OUT.SUCCESS:
      return initialState.invoice;

    default:
      return state;
  }
};
